<template>
  <div class="status" :style="{'color': textColor}">
    <v-progress-circular
      v-if="!isFinished"
      class="status-progress"
      :size="60"
      :value="percentage"
      color="accent">
      {{percentage}}
    </v-progress-circular>

    <div class="status-text">
      <span :class="{'error--text': isFailed}">{{statusDesc}}</span>
      <!-- <v-btn
        v-if="isFailed"
        @click="$emit('retry')"
        color="accent"
        small
        flat>
        重試
      </v-btn> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Number
    },
    isFinished: {
      type: Boolean
    },
    isFailed: {
      type: Boolean
    },
    statusDesc: {
      type: String
    },
    textColor: {
      type: String,
      default: 'black'
    }
  }
};
</script>

<style lang="stylus" scoped>
.status {
  // position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  padding: 0.5rem;
  flex-direction: column;
}

.status-progress {
  margin-bottom: 0.5rem;
}

.status-text {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
